export default function getResource(label, vars = []) {
    const resources = {
        merchandiseSubtotalText: 'Sous-total des marchandises',
        pickup: 'Ramassage',
        free: 'GRATUIT',
        estimatedTaxText: 'Taxes estimées',
        estimatedTaxCA: 'TVH/TPS/TVP estimées',
        estimatedTotalText: 'Total estimé',
        paymentText: 'Le paiement sera perçu en magasin.',
        reservationDetailsButtonText: 'Voir les détails de la réservation',
        completeReservation: 'Compléter la réservation',
        bagFeeText: 'Frais de sac',
        specialFeeText: 'Frais spéciaux',
        discountsText: 'Réductions',
        eGiftCardRedeemedText: 'Carte-cadeau électronique utilisée',
        payPalPaymentText: 'Paiement PayPal',
        giftCardRedeemedText: 'Carte-cadeau échangée',
        creditCardPaymentText: 'Paiement par carte de crédit',
        storeCredit: 'Crédit magasin',
        beautyInsiderPoints: 'Vous accumulerez des points Beauty Insider pour cet achat après avoir ramassé votre commande.',
        orderTotal: 'Total de la commande',
        gotIt: 'Compris',
        salesTax: 'Taxe de vente',
        tax: 'Taxe',
        caTax: 'TVH/TPS/TVP'
    };

    return resources[label];
}
